module.exports = __webpack_public_path__ + "static/curso_izaje-d482492a216f7d64bfae19346fb39ee4.jpg";